import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import image0 from 'src/assets/logoAnimated/0.png';
import image1 from 'src/assets/logoAnimated/1.png';
import image2 from 'src/assets/logoAnimated/2.png';
import image3 from 'src/assets/logoAnimated/3.png';
import image4 from 'src/assets/logoAnimated/4.png';
import image5 from 'src/assets/logoAnimated/5.png';
import image6 from 'src/assets/logoAnimated/6.png';
import image7 from 'src/assets/logoAnimated/7.png';
import image8 from 'src/assets/logoAnimated/8.png';
import image9 from 'src/assets/logoAnimated/9.png';
import image10 from 'src/assets/logoAnimated/10.png';
import image11 from 'src/assets/logoAnimated/11.png';
import image12 from 'src/assets/logoAnimated/12.png';
import image13 from 'src/assets/logoAnimated/13.png';
import image14 from 'src/assets/logoAnimated/14.png';
import image15 from 'src/assets/logoAnimated/15.png';
import image16 from 'src/assets/logoAnimated/16.png';
import image17 from 'src/assets/logoAnimated/17.png';
import image18 from 'src/assets/logoAnimated/18.png';
import image19 from 'src/assets/logoAnimated/19.png';
import image20 from 'src/assets/logoAnimated/20.png';
import image21 from 'src/assets/logoAnimated/21.png';
import image22 from 'src/assets/logoAnimated/22.png';
import image23 from 'src/assets/logoAnimated/23.png';
import image24 from 'src/assets/logoAnimated/24.png';
import image25 from 'src/assets/logoAnimated/25.png';
import image26 from 'src/assets/logoAnimated/26.png';
import useStyles from './styles';

const images = [
  image0,
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
  image24,
  image25,
  image26
];

const mapStateToProps = state => {
  const { questionsData } = state.questionReducer;
  return {
    questionsData
  };
};

function LoadingPage({ questionsData }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const navigate = useNavigate();

  // Get brand name from questions data, fallback to "your brand" if not available
  const brandName = questionsData?.brand_name || 'your brand';

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex =>
        prevIndex < 26 ? prevIndex + 1 : prevIndex
      );
    }, 300);

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    if (currentIndex === images.length - 1) {
      const timeout = setTimeout(() => {
        navigate('/solution');
      }, 500);

      return () => clearTimeout(timeout);
    }
    return undefined;
  }, [currentIndex, navigate]);

  return (
    <Paper elevation={0} className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.content}>
          <Typography variant="Heading-4" color="black">
            {t('loading.finalisingBusinessCase', { brandName })}
          </Typography>
        </Box>
        <Box className={classes.logoContainer}>
          <img
            src={images[currentIndex]}
            alt="Loading animation"
            className={classes.logo}
          />
        </Box>
      </Box>
    </Paper>
  );
}

LoadingPage.propTypes = {
  questionsData: PropTypes.object
};

export default connect(mapStateToProps)(LoadingPage);
